/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotodraghint4Inputs */

const en_aiflowphotodraghint4 = /** @type {(inputs: Aiflowphotodraghint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag the text to the right spot.`)
};

const de_aiflowphotodraghint4 = /** @type {(inputs: Aiflowphotodraghint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zieh den Text an die richtige Stelle.`)
};

/**
* | output |
* | --- |
* | "Drag the text to the right spot." |
*
* @param {Aiflowphotodraghint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotodraghint4 = /** @type {((inputs?: Aiflowphotodraghint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotodraghint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotodraghint4(inputs)
	return de_aiflowphotodraghint4(inputs)
});
export { aiflowphotodraghint4 as "aiFlowPhotoDragHint" }